import { memoize } from 'lodash-es';
import { useEffect, useState, useMemo } from 'react';

import { nonAuthClient } from 'common/graphql/client';

import { setBackendFxIntegrationEnabled, defaultFlags, featureFlags } from '../featureFlags';
import { shouldUseFx } from '../gqlQueries';

export interface FxIntegrationState {
    isInitialized: boolean;
    waitForInitialization: () => Promise<boolean>;
}
// TODO: rework to context / redux with initialisation state and data
export function useFxIntegrationInitialization(): FxIntegrationState {
    const [state, setState] = useState({
        isInitialized: false,
    });

    const initializeFromBackend = useMemo(
        () =>
            memoize(async (): Promise<boolean> => {
                try {
                    const response = await nonAuthClient.query({ query: shouldUseFx });
                    const shouldUseFxValue = response?.data?.shouldUseFx ?? defaultFlags.fxIntegration;

                    setBackendFxIntegrationEnabled(shouldUseFxValue);
                    setState({
                        isInitialized: true,
                    });

                    return shouldUseFxValue;
                } catch {
                    setBackendFxIntegrationEnabled(defaultFlags.fxIntegration);
                    setState({
                        isInitialized: true,
                    });

                    return defaultFlags.fxIntegration;
                }
            }),
        []
    );

    const waitForInitialization = useMemo(() => {
        return async (): Promise<boolean> => {
            if (state.isInitialized) {
                return featureFlags.fxIntegration;
            }

            return initializeFromBackend();
        };
    }, [state.isInitialized, featureFlags.fxIntegration, initializeFromBackend]);

    useEffect(() => {
        if (!state.isInitialized) {
            initializeFromBackend();
        }
    }, [initializeFromBackend, state.isInitialized]);

    return {
        ...state,
        waitForInitialization,
    };
}
